module.exports = __webpack_public_path__ + "static/media/challenge-date.347ae442.svg";